var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "JadeFloating",
    _vm._b(
      {
        attrs: {
          open: _vm.open,
          closeOn: _vm.closeOn,
          zIndex: _vm.zIndex,
          allowOutsideClick: "",
        },
        on: { toggle: () => _vm.$emit("toggle") },
      },
      "JadeFloating",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "div",
        {
          staticClass: "jade-drawer",
          class: { slideIn: _vm.open, slideOut: !_vm.open },
          staticStyle: {
            transform: "translateX(0px)",
            "transition-property": "transform",
            "transition-duration": "250ms",
          },
          attrs: { tabindex: "-1" },
        },
        [
          _c(
            "div",
            { staticClass: "jade-drawer__container" },
            [
              _c("JadeNavigationBar", {
                attrs: {
                  navigateType: "close",
                  background: "surface",
                  label: _vm.title,
                  trailingAction: _vm.trailingAction,
                },
                on: {
                  trailingActionClick: () => _vm.$emit("trailingActionClick"),
                  onNavigate: () => _vm.$emit("toggle"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "trailingItem",
                      fn: function () {
                        return [_vm._t("trailingItem")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c(
                "main",
                { class: _vm.computedClassMain },
                [
                  _vm.loading
                    ? _c("JadeSpinner", {
                        attrs: { size: "xlarge", color: "medium" },
                      })
                    : _vm._t("default"),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }